export const pgmDetail = [
  // { id: 'evt029_c001', value: 'Abdominal Wall Reconstruction' },

  // { id: 'evt029_c001', value: 'Abdominal Wall Reconstruction' },
  // { id: 'evt029_c002', value: 'Aesthetic Breast' },
  // { id: 'evt029_c036', value: 'Aesthetic Video Session' },
  // { id: 'evt029_c003', value: 'Antiaging' },
  // { id: 'evt029_c004', value: 'Asian Blepharoplasty Forum' },
  // { id: 'evt029_c005', value: 'Basic Research' },
  // { id: 'evt029_c006', value: 'Bone Contouring' },
  // { id: 'evt029_c007', value: 'Botox, Filler & Thread' },
  // { id: 'evt029_c008', value: 'Breast Reconstruction' },
  // { id: 'evt029_c009', value: 'Craniofacial' },
  // // { id: 'evt029_c010', value: 'Craniofacial Reconstruction Surgery' },
  // { id: 'evt029_c011', value: 'Facial Nerve' },
  // { id: 'evt029_c012', value: 'Facial Trauma' },
  // { id: 'evt029_c013', value: 'Fat and Stem Cells' },
  // { id: 'evt029_c014', value: 'Forehead Surgery' },
  // { id: 'evt029_c015', value: 'Free Paper' },
  // // { id: 'evt029_c016', value: 'Gender Affirming Surgery' },
  // { id: 'evt029_c017', value: 'Hair' },
  // { id: 'evt029_c018', value: 'Hand' },
  // { id: 'evt029_c019', value: 'Industrial Session' },
  // // { id: 'evt029_c020', value: 'Invitation Session' },
  // // { id: 'evt029_c021', value: 'Invited Lecture (Sponsored by Hallym)' },
  // { id: 'evt029_c022', value: 'Keynote Lecture' },
  // { id: 'evt029_c023', value: 'Korean Wound Management Society' },
  // { id: 'evt029_c024', value: 'Laser' },
  // { id: 'evt029_c025', value: 'LGBTQ Medicine/Gender Affirming Surgery' },
  // { id: 'evt029_c026', value: 'Lymphedema' },
  // { id: 'evt029_c027', value: 'MIPS' },
  // { id: 'evt029_c028', value: 'Perforator' },
  // { id: 'evt029_c029', value: 'Peripheral Nerve' },
  // { id: 'evt029_c030', value: 'Retirement Lecture' },
  // { id: 'evt029_c031', value: 'Rhinoplasty' },
  // { id: 'evt029_c032', value: 'Robot Surgery' },
  // { id: 'evt029_c033', value: 'Scar Management' },
  // // { id: 'evt029_c034', value: 'Songbaek Lecture' },
  // { id: 'evt029_c035', value: 'Vascularized Composite Allotransplantation' },
  // // { id: 'evt029_c036', value: 'Video Session' },
  // { id: 'evt029_c037', value: '보험 세션, 신의료기술' },
  // { id: 'evt029_c038', value: '필수평점 강의' },

  { id: 'evt120_c000', value: 'Academic Collaboration Session' },
  { id: 'evt120_c001', value: 'Aesthetic Breast' },
  { id: 'evt120_c002', value: 'Allotransplantation' },
  { id: 'evt120_c003', value: 'Antiaging' },
  { id: 'evt120_c004', value: 'AR, VR Session' },
  { id: 'evt120_c005', value: 'Fat and Stem Cells' },
  { id: 'evt120_c006', value: 'Basic Research' },
  { id: 'evt120_c007', value: 'Blepharoplasty' },
  { id: 'evt120_c008', value: 'Botox, Filler & Thread' },
  { id: 'evt120_c009', value: 'Breast Reconstruction' },
  { id: 'evt120_c010', value: 'Craniofacial' },
  { id: 'evt120_c011', value: 'Facial Contouring Surgery' },
  { id: 'evt120_c012', value: 'Facial Nerve' },
  { id: 'evt120_c013', value: 'Facial Rejuvenation' },
  { id: 'evt120_c014', value: 'Facial Trauma' },
  // { id: 'evt120_c015', value: 'Fat and Stem Cells' },
  { id: 'evt120_c016', value: 'Free Paper' },
  { id: 'evt120_c017', value: 'Gender' },
  { id: 'evt120_c018', value: 'Hair' },
  { id: 'evt120_c019', value: 'Hand' },
  { id: 'evt120_c020', value: 'Head and Neck Reconstruction' },
  // { id: 'evt120_c021', value: 'Memorial Session in honor of the late Prof Jae Duk Lew (松佰)' },
  { id: 'evt120_c022', value: 'Industrial Session' },
  // { id: 'evt120_c023', value: 'Keynote lecture' },
  { id: 'evt120_c023', value: 'Lecture' },
  { id: 'evt120_c024', value: 'Laser' },
  // { id: 'evt120_c025', value: 'Laser Hands-on Session' },
  { id: 'evt120_c026', value: 'Lower Extremities Reconstruction' },
  { id: 'evt120_c027', value: 'Lymphedema' },
  { id: 'evt120_c028', value: 'Memorial Session in honor of the late Prof Jae Duk Lew (松佰)' },
  // { id: 'evt120_c028', value: 'Middle East Session' },
  { id: 'evt120_c029', value: 'Minimally Invasive' },
  // { id: 'evt120_c030', value: 'MOU Session' },
  { id: 'evt120_c031', value: 'Perforator' },
  { id: 'evt120_c032', value: 'Peripheral Nerves' },
  { id: 'evt120_c033', value: 'Publication Strategy for International Journal' },
  { id: 'evt120_c034', value: 'Retirement lecture' },
  { id: 'evt120_c035', value: 'Rhinoplasty' },
  { id: 'evt120_c036', value: 'Robot Surgery' },
  { id: 'evt120_c037', value: 'Scar Management' },
  { id: 'evt120_c038', value: 'Wound Management' },
  { id: 'evt120_c039', value: '필수평점' },
];
